export enum DeviceTypes {
  Camera = 0,
  Desktop = 1,
  Web = 2,
  MobileIOS = 3,
  MobileAndroid = 4,
  Other = 20,
}

export enum DeviceStatuses {
  Unassigned = 0,
  Assigned = 1,
}
